import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

const initialState = {
  isFetching: false,
  data: {},
  livePlayerData: {},
  isLoggedIn: false
};

export const liveDoubtClassReducer = createReducer(initialState, {
  [types.LIVE_DOUBT_CLASS_RESPONSE](state, action) {
    return {
      ...state,
      timestamp: action.response.timestamp,
      data: action.response.data,
      errorMessage: action.response.message
    };
  },
  [types.LIVE_DOUBT_CLASS_DETAIL_RESPONSE](state, action) {
    return {
      ...state,
      livePlayerData: action.response.data,
      errorMessage: action.response.message
    };
  },
  [types.LOG_OUT]() {
    return {
      ...initialState
    };
  }
});
